// extracted by mini-css-extract-plugin
export default {"container":"swiper_container__FpmmQ","swiperContainer":"swiper_swiperContainer__bbtjo","swiperSlide":"swiper_swiperSlide__G2y78","pagination":"swiper_pagination__-v0kT"};